import { h, render } from "preact";
import RichText from "../helpers/richText";
import CompareContentItem from "./compareContentItem";

export default function ContentRowContent({ products, rowIndex }) {
  return (
    <div className="compare-modal-v2__row-items compare-modal-v2__content-row-items">
      {products.map((product) => (
        <div className="compare-modal-v2__row-item">
          {product.compareContent[rowIndex] ? (
            <CompareContentItem
              compareContent={product.compareContent[rowIndex]}
            />
          ) : (
            "-"
          )}
        </div>
      ))}
    </div>
  );
}
